<template>
	<div v-if="isVisible && currentTip" class="update-tips-overlay" @click="handleOverlayClick">
		<div class="update-tips-card" :style="tipPosition" @click.stop>
			<!-- 视频区域 -->
			<div class="video-container" v-if="currentTip.url">

				<img :src="currentTip.url" alt="" class="video-image" />

			</div>

			<!-- 内容区域 -->
			<div class="content-container">
				<h3 v-if="currentTip.name" class="tip-title">{{ currentTip.name }}</h3>
				<p class="tip-content">{{ currentTip.content }}</p>

				<!-- 操作按钮 -->
				<div class="action-buttons">
					<button class="btn-primary" @click="handleKnowIt">知道了</button>
				</div>
			</div>

			<!-- 箭头指示器 -->
			<div class="arrow" :class="`arrow-${currentTip.position}`"></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { updateTipsManager } from '@/utils/updateTipsManager'
import { getFeatureRemindList, addBubbleRecord } from '@/api/guide'
const videoRef = ref<HTMLVideoElement | null>(null)
const isVideoPlaying = ref(false)

// 使用管理器的状态
const currentTip = computed(() => updateTipsManager.currentTip.value)
const isVisible = computed(() => updateTipsManager.isVisible.value)
const tipPosition = computed(() => updateTipsManager.tipPosition.value)

// 视频相关处理
const handleVideoHover = () => {
	if (videoRef.value && !isVideoPlaying.value) {
		videoRef.value.play()
		isVideoPlaying.value = true
	}
}

const handleVideoLeave = () => {
	if (videoRef.value && isVideoPlaying.value) {
		videoRef.value.pause()
		isVideoPlaying.value = false
	}
}

// 防抖处理，避免快速连击
const isClosing = ref(false)
// import { addBubbleRecord } from '@/api/guide'
// 知道了按钮处理
const handleKnowIt = async () => {
	console.log('知道了!!!!!!!!!!!!!!!!!')

		if (isClosing.value) return // 防止重复点击

		isClosing.value = true
		console.log('关闭提示:', currentTip.value?.id)
		updateTipsManager.closeTip()

		// 重置防抖标志
		setTimeout(() => {
			isClosing.value = false
		}, 200)
	}

// 点击遮罩层关闭
const handleOverlayClick = () => {
	updateTipsManager.closeTip()
}

// 监听窗口大小变化和滚动，重新计算位置
const handleResize = () => {
	if (currentTip.value) {
		// 如果当前有提示，重新计算位置
		const element = document.querySelector(currentTip.value.selector) as HTMLElement
		if (element) {
			const position = updateTipsManager.calculatePosition(currentTip.value, element)
			updateTipsManager.tipPosition.value = position
		}
	}
}

const handleScroll = () => {
	handleResize() // 滚动时也需要重新计算位置
}

onMounted(() => {
	window.addEventListener('resize', handleResize)
	window.addEventListener('scroll', handleScroll, true) // 使用捕获阶段
})

onUnmounted(() => {
	window.removeEventListener('resize', handleResize)
	window.removeEventListener('scroll', handleScroll, true)
})
</script>

<style scoped lang="less">
.update-tips-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.1);
	// background: #181613;
	z-index: 9998;
	pointer-events: auto;
}

.update-tips-card {
	// background: #fff;
	background: #181613;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 8px 32px rgba(0, 0, 0, 0.12),
		0 0 0 1px rgba(0, 0, 0, 0.04);
	width: 320px;
	max-width: 90vw;
	// overflow: hidden;
	position: relative;
	backdrop-filter: blur(10px);

	.video-container {
		position: relative;
		width: 100%;
		height: 180px;
		background: #f5f5f5;
		overflow: hidden;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;

		video {
			width: 100%;
			height: 100%;
			object-fit: cover;
			cursor: pointer;
		}

		.video-overlay {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(0, 0, 0, 0.2);
			transition: opacity 0.3s ease;

			.play-icon {
				width: 48px;
				height: 48px;
				border-radius: 50%;
				background: rgba(255, 255, 255, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				color: #333;
				cursor: pointer;
				transition: transform 0.2s ease;

				&:hover {
					transform: scale(1.1);
				}
			}
		}

		&:hover .video-overlay {
			opacity: 0;
		}
		.video-image {
			border-top-left-radius: 8px;
			border-top-right-radius: 8px;
		}
	}

	.content-container {
		padding: 20px;
		background: #212121;

		border-radius: 8px;
		padding: 20px;
		box-shadow: 0px 0px 10px 0px #0d111a;
		.tip-title {
			font-size: 16px;
			font-weight: 600;
			color: #ffffff;
			margin: 0 0 12px 0;
			line-height: 1.4;
		}

		.tip-content {
			font-size: 14px;
			color: #ccc8c2;
			line-height: 1.6;
			margin: 0 0 20px 0;
		}

		.action-buttons {
			display: flex;
			justify-content: flex-end;
			margin: 0; // 确保按钮区域没有额外margin
			.btn-primary {
				border: none;
				font-weight: 500;
				cursor: pointer;
				transition: background-color 0.2s ease;
				min-width: 63px;
				width: 63px;
				height: 24px;
				background: rgba(255, 213, 144, 0.2);
				border-radius: 4px 4px 4px 4px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 13px;
				color: #fbd38d;
				line-height: 20px;
				&:hover {
				}
			}
		}
	}

	// 箭头指示器 - 优化指引样式
	.arrow {
		position: absolute;
		// 使用伪元素创建带阴影的三角
		&::after {
			content: '';
			position: absolute;
			width: 0;
			height: 0;
			border: 10px solid transparent;
			filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
		}

		主体层（白色三角） &::after {
			border: 10px solid transparent;
		}

		&.arrow-top {
			left: 50%;
			transform: translateX(-50%);

			&::after {
				border-top-color: #181613;
				top: 0;
			}
		}

		&.arrow-bottom {
			left: 50%;
			transform: translateX(-50%);

			&::after {
				border-bottom-color: #181613;
				bottom: 0;
			}
		}

		&.arrow-left {
			top: 50%;
			transform: translateY(-50%);

			&::after {
				border-left-color: #181613;
				left: 0;
			}
		}

		&.arrow-right {
			top: 50%;
			transform: translateY(-50%);

			&::after {
				border-right-color: #181613;
				right: 0;
			}
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.update-tips-card {
		width: 280px;

		.video-container {
			height: 160px;
		}

		.content-container {
			padding: 16px;
			background: linear-gradient(45deg, #181613 20%, #0f0c08 80% /* 改用更深的颜色 */),
				radial-gradient(100% 100% at 100% 0%, rgba(255, 82, 25, 0.4) 0%, rgba(255, 82, 25, 0) 70%);
			border-radius: 8px;
			padding: 20px;
			box-shadow: 0px 0px 10px 0px #0d111a;
			.tip-title {
				font-size: 15px;
				color: #ffffff;
			}

			.tip-content {
				font-size: 13px;
				color: #ccc8c2;
			}
		}
	}
}

// 添加动画效果
.update-tips-card {
}
</style>
